import React from 'react';

import { requestPost, } from '../../../../modules/request/index';

export default class MergeClasses extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      primaryClassCode: '',
      secondaryClassCodes: '',
      submitting: false
    }
  }

  submitData = () => {
    const that = this

    this.setState({ submitting: true, error: null })
    requestPost(
      `${window.postbuildEnv.DEFAULT_URL}/teacher_fix/merge_classes`,
      { primary_class_code: that.state.primaryClassCode, secondary_class_codes: that.state.secondaryClassCodes },
      (body) => {
        if (body.error) {
          that.setState({ submitting: false, error: body.error })
        } else {
          that.setState({ submitting: false, error: null })
          window.alert('Classes have been merged!')
        }
      },
      (body) => {
        that.setState({ submitting: false, error: body.error || 'Something went wrong. Please check whether the merge completed before retrying.' })
      }
    ).catch(() => {
      that.setState({ submitting: false, error: 'Something went wrong. Please check whether the merge completed before retrying.' })
    })
  };

  updatePrimaryClassCode = (e) => {
    this.setState({ primaryClassCode: e.target.value })
  };

  updateSecondaryClassCodes = (e) => {
    this.setState({ secondaryClassCodes: e.target.value })
  };

  renderError() {
    if (this.state.error) {
      return <p className="error">{this.state.error}</p>
    }
  }

  render() {
    return (
      <div>
        <h1><a href="/teacher_fix">Teacher Fixes</a></h1>
        <h2>Merge Provider-Synced Classes (Reversible)</h2>
        <p>Use this for classes that roster from a provider (Clever, Google Classroom, Canvas, ClassLink). Unlike "Merge Two Classrooms", this does not move data or archive anything: each secondary class stays a separate, fully-intact class that keeps its assignments and provider link so it continues to sync. The secondary class is nested under the primary class and its students are also added to the primary class.</p>
        <p>The primary and secondary classes must have the same owner. This action can be undone with the <a href="/teacher_fix/unmerge_classes">Unmerge Provider-Synced Classes</a> fix.</p>
        <div>
          <div className="input-row">
            <label htmlFor="primary-class-code">Primary Class Code:</label>
            <input id="primary-class-code" onChange={this.updatePrimaryClassCode} type="text" value={this.state.primaryClassCode} />
          </div>
          <div className="input-row">
            <label htmlFor="secondary-class-codes">Secondary Class Code(s):</label>
            <input id="secondary-class-codes" onChange={this.updateSecondaryClassCodes} placeholder="Separate multiple codes with commas" type="text" value={this.state.secondaryClassCodes} />
          </div>
          <button disabled={this.state.submitting} onClick={this.submitData} type="button">
            {this.state.submitting ? 'Merging… (this can take a minute)' : 'Merge Classes'}
          </button>
          {this.renderError()}
        </div>
      </div>
    )
  }
}
